// extracted by mini-css-extract-plugin
export var bubble = "_v-0";
export var container = "_v-f";
export var contrastBorder = "_v-g";
export var greyOut = "_v-2";
export var initialsColor0 = "_v-3";
export var initialsColor1 = "_v-4";
export var initialsColor10 = "_v-d";
export var initialsColor11 = "_v-e";
export var initialsColor2 = "_v-5";
export var initialsColor3 = "_v-6";
export var initialsColor4 = "_v-7";
export var initialsColor5 = "_v-8";
export var initialsColor6 = "_v-9";
export var initialsColor7 = "_v-a";
export var initialsColor8 = "_v-b";
export var initialsColor9 = "_v-c";
export var initialsWrapper = "_v-1";
export var large = "_v-l";
export var medium = "_v-k";
export var mediumSmall = "_v-j";
export var mediumSmallMedium = "_v-o";
export var micro = "_v-h";
export var small = "_v-i";
export var tiny = "_v-n";
export var xTiny = "_v-m";